<template>
    <v-container>
        <v-row class="px-3">
            <v-col cols="12" lg="6">
                <h1>
                    {{ hobbies[0].name }}
                </h1>
                <v-card>
                    <v-card-text>
                        {{ hobbies[0].description }}
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" lg="6">

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        data() {
            return {
                hobbies: [
                    {
                        name: "Photograph",
                        description: "When I studied in middle school, I had a lot of experience being a documentary at many outside or inside school events. Because of that I now very like to photograph."
                    }
                ]
            }
        }
    }
</script>